module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/separation-mobile-phone.30f2551a.png";